import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { UtilService } from 'src/app/services/utils.service';
import { GateWayService } from '../../../services/gateway-service.service';
import { environment } from 'src/environments/environment';

declare const $:any;

@Component({
  selector: 'app-manage-child-org-edit',
  templateUrl: './manage-child-org-edit.component.html',
  styleUrls: ['./manage-child-org-edit.component.scss','../../platform-color/platform-color.scss']
})
export class ManageChildOrgEditComponent implements OnInit {
  form: FormGroup;
  submitted: boolean = false;
  load: boolean = false;
  
  image = null;
  selectFile = null;

  name: string;
  childOrg: any;

  sizeFileOver: boolean = false;
  typeFileOver: boolean = false;

  provinces = [];
  districts = [];
  subdistricts = [];

  successModal: string = '#successModal';
  statusModal: string = '#statusModal';
  errorModal: string = '#errorModal';

  upload = environment.URL_UPLOAD;
  org_id: string;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private UtilService: UtilService,
    private GateWayService: GateWayService,
    private cd: ChangeDetectorRef,
  ) {
    this.name = this.route.snapshot.paramMap.get("name");
    this.route.queryParams
    .subscribe(params => {
      this.org_id = params.org_id;
    })
   }
  ngOnInit() {
    this.createForm();
    this.UtilService.getProvinces().subscribe(res=>{
      this.provinces = res.data.sort((a, b) => a.name_th > b.name_th ? 1 : -1) || [];
    })
    this.valueChange();

    this.spinner.show();


    setTimeout(() => {
      this.getChildorgByName();
    }, 1000);
  }

  getChildorgByName(){
    this.GateWayService.getChildOrgByName(this.name).subscribe(res=>{
      this.childOrg = res.data.find(child=> child.org_id == this.org_id);

      if(this.childOrg.profile_img ){
        this.image = this.childOrg.profile_img;
      }

      let data = {
        name: this.childOrg.name,
        province_code: this.childOrg.province.code,
        province_name_th: this.childOrg.province.name_th,
        active: this.childOrg.active
      }

      this.form.patchValue(data);


      this.spinner.hide();
    })
  }

  createForm(){
    this.form = this.formBuilder.group({
      name: ["", [Validators.required]],
      province_id: [""],
      province_code: ["", [Validators.required]],
      province_name_th: [""],
      subdistrict_id: [""],
      subdistrict_code: ["", [Validators.required]],
      subdistrict_name_th: [""],
      district_id: [""],
      district_code: ["", [Validators.required]],
      district_name_th: [""],
      zipcode: [""],
      active: [true],
    })
  }

  valueChange(){
    this.form.controls.province_code.valueChanges.subscribe(
      (value) => {

        if(value != this.form.value['province_code']){
      
          let province = this.provinces.find(province => province.code == value);

          if(province){
            this.form.get('province_id').setValue(province.id);
            this.form.get('province_name_th').setValue(province.name_th);
            this.spinner.show();
            this.UtilService.getDistricts(province.id).subscribe(res=>{
              this.districts = res.data.sort((a, b) => a.name_th > b.name_th ? 1 : -1) || [];

              if(this.childOrg.district.code && this.load == false){
                this.form.get('district_code').setValue(this.childOrg.district.code);
              }
              this.spinner.hide();
            });
          }

          this.form.get('district_code').setValue("");
          this.form.get('district_id').setValue("");
          this.form.get('district_name_th').setValue("");

          this.form.get('subdistrict_code').setValue("");
          this.form.get('subdistrict_id').setValue("");
          this.form.get('subdistrict_name_th').setValue("");
          this.form.get('zipcode').setValue("");
        }
      }
    );

    this.form.controls.district_code.valueChanges.subscribe(
      (value) => {
       if(value != this.form.value['district_code']){
        let district = this.districts.find(district => district.code == value);

        if(district){
          this.form.get('district_id').setValue(district.id);
          this.form.get('district_name_th').setValue(district.name_th);
          this.spinner.show();
          this.UtilService.getSubDistricts(district.id).subscribe(res=>{
            this.subdistricts = res.data.sort((a, b) => a.name_th > b.name_th ? 1 : -1) || [];

            if(this.childOrg.subdistrict.code && this.load == false){
              this.form.get('subdistrict_code').setValue(this.childOrg.subdistrict.code);

              this.load = true;
            }
            this.spinner.hide();
          });
        }


        this.form.get('subdistrict_code').setValue("");
        this.form.get('subdistrict_id').setValue("");
        this.form.get('subdistrict_name_th').setValue("");
        this.form.get('zipcode').setValue("");
       }
      }
    );

    this.form.controls.subdistrict_code.valueChanges.subscribe(
      (value) => {

        if(value != this.form.value['subdistrict_code']){
          let subDistrict = this.subdistricts.find(subdistrict => subdistrict.code == value);

          if(subDistrict){
            this.form.get('subdistrict_id').setValue(subDistrict.id);
            this.form.get('subdistrict_name_th').setValue(subDistrict.name_th);
            this.form.get('zipcode').setValue(subDistrict.zipcode);
          }
        }
      }
    );

    this.form.controls.active.valueChanges.subscribe(
      (value) => {
        if(value != this.form.value['active']){
          $(this.statusModal).modal("show");
        }
      }
    );
  }

  reset(){
    this.cd.detectChanges();
  }

  get f() {
    return this.form.controls;
  }

  uploadImage(){
    document.getElementById("image_file").click();
  }

  onFileChange(file){
    this.spinner.show();
    this.selectFile = <File>file[0];

    var mimeType = this.selectFile.type;
    var size = this.selectFile.size;

    if(size >= 100000000){
      this.sizeFileOver = true;
    }else{
      this.sizeFileOver = false;
    }

    if(mimeType.includes("jpeg") || mimeType.includes("png")){
      this.typeFileOver = false;
    }else{
      this.typeFileOver = true;
    }

    var reader = new FileReader();      
    reader.readAsDataURL(this.selectFile); 
    reader.onload = (_event) => { 
      this.image = reader.result; 
      this.spinner.hide();
    }
  }

  deleteFile(){
    this.image = null;
  }

  save(){
    console.log(this.form.value, this.form.invalid, this.sizeFileOver,    this.typeFileOver, this.image)
    this.submitted = true;
    if(
      this.form.invalid ||
      this.sizeFileOver ||
      this.typeFileOver
    ){
      return;
    }

    if(this.selectFile){
      let formData = new FormData();
      formData.append("image", this.selectFile);
      this.UtilService.uploadImage(formData).subscribe(res=>{
        if(res.code == 200){
          this.saveChildOrg(res.data.path);
        }
      })
    }else{
      this.saveChildOrg();
    }
  }

  saveChildOrg(path = null){
    let value = this.form.value;
    let data = {
      org_id: this.childOrg.org_id,
      child_org_id: this.childOrg._id,
      "name": value.name,
      "profile_img": path? path: this.image? this.image: path,
      "subdistrict":  {
          "code" : value.subdistrict_code,
          "name_th" : value.subdistrict_name_th,
          "zipcode" : value.zipcode
      },
      "district":  {
          "code" : value.district_code,
          "name_th" : value.district_name_th,
      },
      "province":  {
          "code" : value.province_code,
          "name_th" : value.province_name_th,
      },
      active: value.active
    }

    this.GateWayService.updateChildOrg(data).subscribe(res=>{
      if(res.code == 200){
        $(this.successModal).modal("show");
      }else{
        if(res.message == 'Data existed'){
          $(`${this.errorModal}`).modal("show");
        }
      }
    })
  }
}
